import {
  ComponentRef,
  Directive,
  Host,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewContainerRef,
} from '@angular/core';
import { NgControl, ValidationErrors } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY, merge, Observable, startWith } from 'rxjs';
import { ControlErrorComponent } from '../../components/control-error/control-error.component';
import { FormErrorName, FORM_ERRORS } from '../../token/error.token';
import { FormSubmitDirective } from '../form-submit/form-submit.directive';

@Directive({
  selector: '[formControl], [formControlName]',
})
@UntilDestroy()
export class ControlErrorsDirective implements OnInit {
  componentRef!: ComponentRef<ControlErrorComponent>;
  submit$: Observable<Event>;
  @Input() customErrors: ValidationErrors = {};

  constructor(
    private viewContainerRef: ViewContainerRef,
    @Inject(FORM_ERRORS) private errors: FormErrorName,
    @Optional() @Host() private form: FormSubmitDirective,
    private controlDir: NgControl
  ) {
    this.submit$ = this.form ? this.form.submit$ : EMPTY;
  }

  ngOnInit() {
    if (this.control) {
      merge(
        this.submit$,
        this.control.valueChanges.pipe(startWith(this.control.value))
      )
        .pipe(untilDestroyed(this))
        .subscribe(() => {
          this.showError();
        });
    }
  }

  showError() {
    if (!this.control) return;
    const controlErrors = this.control.errors;

    if (controlErrors) {
      const firstKey = Object.keys(controlErrors)[0];
      const getError = this.errors[firstKey];

      if (!this.customErrors[firstKey]) {
        return;
      }
      const text =
        this.customErrors[firstKey] || getError(controlErrors[firstKey]);
      this.setError(text);
      return;
    }

    if (this.componentRef) {
      this.setError('');
    }
  }

  get control() {
    return this.controlDir.control;
  }

  setError(text: string) {
    if (!this.componentRef) {
      this.componentRef = this.viewContainerRef.createComponent(
        ControlErrorComponent
      );
    }

    this.componentRef.instance.text = text;
  }
}
